module.exports = __webpack_public_path__ + "media/Video 144b.5410078f.mp4";